import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AzureadHelperService } from '../azuread-helper.service';

@Component({
  selector: 'app-tenant-chooser',
  templateUrl: './tenant-chooser.component.html',
  styleUrls: ['./tenant-chooser.component.css']
})
export class TenantChooserComponent implements OnInit {

  tenants: Object;
  constructor(private router: Router, private azureService: AzureadHelperService) { }

  ngOnInit() {
    this.azureService.getTenants().toPromise().then(tenants => {
      //this.tenants = tenants.value;
    })
  }

  chooseTenant(){
    this.router.navigate(['/', { }]);
  }

}
